import type { DefinitionRow } from '../../masterdevelopment/framework';

type Props = { items?: DefinitionRow[] };

export function DefinitionReadyDonePanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={`${item.type}-${item.item}`} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs font-medium text-brand-600">{item.type}</p>
              <p className="text-sm font-medium">{item.item}</p>
            </div>
            <span className="shrink-0 text-sm font-semibold text-brand-600">{item.score}%</span>
          </div>
          <p className="mt-1 text-xs text-slate-500">{item.status}</p>
        </div>
      ))}
    </div>
  );
}
